<template>
    <span v-if="simple && noLink">
        {{ parsedEmail }}
    </span>
    <a v-else-if="simple" :href="`mailto:${parsedEmail}`">
        {{ parsedEmail }}
    </a>
    <div v-else class="flex truncate flex-nowrap items-center" v-bind="$attrs" v-on="$listeners">
        <slot v-if="!hideIcon" name="icon">
            <vx-basic-icon v-if="!hideIcon" class="mr-3" icon="MailIcon" />
        </slot>
        <span class="truncate">
            <template v-if="hasEmail && isValid">
                <span v-if="noLink">
                    {{ parsedEmail }}
                </span>
                <a v-else :href="`mailto:${parsedEmail}`">
                    {{ parsedEmail }}
                </a>
            </template>
            <span v-else class="disabled" :class="{ 'text-danger': !isValid }">
                {{ parsedEmail }}
                <span v-if="!isValid">*</span>
            </span>
            <slot name="append"></slot>
        </span>
    </div>
</template>

<script>
import { email } from '@/plugins/helpers/regex_helpers'

export default {
    name: 'vx-email',
    props: {
        value: {
            type: String
        },
        htmlTag: {
            type: String,
            default: 'span'
        },
        hideIcon: {
            type: Boolean,
            default: false
        },
        noLink: {
            type: Boolean,
            default: false
        },
        simple: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasEmail() {
            return !!this.value
        },
        parsedEmail() {
            if (this.hasEmail) {
                return this.value.toLowerCase()
            }
            return 'No email'
        },
        isValid() {
            return email.IS_VALID_REGEX.test(this.parsedEmail)
        }
    }
}
</script>
